module.exports = __webpack_public_path__ + "img/products_big_can_apricot.a758b7f7.png";